// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"37fff032","100":"5ded50c8","214":"308b7b63","240":"4a62c649","460":"d33cc96d","562":"43792f56","774":"55b1b133","800":"f294fe7d"}[chunkId] + ".chunk.js";
};